import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class PrecipitationECAttribute extends Sensor {
  public precipitationECChart: any;
  private precipitationECSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.precipitationECChart = null;
    this.precipitationECSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.precipitationECSensor, position);
      this.precipitationECSensor[position].push([timestamp, element.precipitationEC]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredPrecipitationEC = this.precipitationECSensor.filter(series => series.length > 0);

    const positionNodePrecipitationEC = this.precipitationECSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.precipitationECChart = this.getConfigChar(
      'precipitationEC',
      this.getChartSeriesNewNode('Sensor', filteredPrecipitationEC, positionNodePrecipitationEC),
      this.getRanges('precipitationEC'),
      this.getLimits('precipitationEC')
    );
  }

  public hasPrecipitationECSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.precipitationECSensor.length &&
      this.precipitationECSensor[index].length > 0
    );
  }

  public getPrecipitationECSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.precipitationECSensor.length) {
      const sensorData = this.precipitationECSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Precipitación Eléctrica', value: 'precipitationEC' }
    ];
  }
}
